import React, { memo, useState } from "react";

import CommonModal from "./CommonModal";
import { Button, Switch } from "../Components";
import Icon from "../assets/icons/Icon";

const ConfimationModal = ({
  getValue,
  onStatusChange,
  isBtn = false,
  btnText = "",
  btnClass = "",
  isSwitch = false,
  isIcon = false,
  iconName = "",
  disabled = false,
}) => {
  const [isShow, setIsShow] = useState(false);

  const handleShowHide = () => {
    setIsShow(!isShow);
  };

  const handleCheckboxChange = (e) => {
    e.target.blur();
    setIsShow(true);
  };

  return (
    <>
      {isSwitch && (
        <Switch
          getValue={getValue}
          onChange={handleCheckboxChange}
          value={getValue}
          disabled={disabled}
        />
      )}

      {isBtn && (
        <Button
          className={`btn-sm ${btnClass}`}
          onClick={() => {
            onStatusChange(!getValue);
            handleShowHide();
          }}
          isDisabled={disabled}
        >
          {btnText}
        </Button>
      )}

      {isIcon && (
        <Icon
          name={iconName}
          className="btn btn-outline-danger icon_button"
          cursorPointer={true}
          onClick={() => setIsShow(true)}
          disabled={disabled}
        />
      )}

      {isShow && (
        <CommonModal
          isShow={isShow}
          handleShowHide={handleShowHide}
          modalTitle="Change Status"
          isFooter={false}
        >
          <div className="row m-0 p-0">
            <div className="col-md-12 m-0 p-1">
              <h5 className="mb-1">Do you want to change?</h5>
            </div>
            <div className="col-md-12 m-0 p-1 d-flex align-items-center justify-content-end">
              <Button
                className="btn-outline-danger mx-2"
                onClick={() => handleShowHide()}
              >
                No
              </Button>
              <Button
                className="btn-primary"
                onClick={() => {
                  onStatusChange(!getValue);
                  handleShowHide();
                }}
              >
                Yes
              </Button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};

export default memo(ConfimationModal);
